import {DataStatus} from 'platform/components';
import {Box, Show, VStack} from 'platform/foundation';

import {ContextTarget, useGetChecklistQuery} from '@dms/api/core';

import {EmptyState} from './components/EmptyState';
import {Overview} from './components/Overview';
import {ChecklistResourceType} from './types/ChecklistResourceType';

export interface ChecklistsProps {
  recordId: string;
  resourceId: keyof typeof ChecklistResourceType;
  contextTarget?: ContextTarget;
  contextId?: string;
  isReadOnly?: boolean;
}

export function Checklists(props: ChecklistsProps) {
  const checklistDetailQuery = useGetChecklistQuery({
    recordId: props.recordId,
    resourceId: props.resourceId,
  });

  const hasChecklist = checklistDetailQuery.data && !checklistDetailQuery.isError;

  return (
    <Box width="100%">
      <VStack align="center">
        <DataStatus isLoading={checklistDetailQuery.isLoading}>
          <Show when={hasChecklist}>
            <Overview
              recordId={props.recordId}
              resourceId={props.resourceId}
              contextTarget={props.contextTarget}
              contextId={props.contextId}
              data={checklistDetailQuery.data!}
              isUpdating={checklistDetailQuery.isFetching}
              isReadOnly={props.isReadOnly}
            />
          </Show>
          <Show when={!hasChecklist}>
            <EmptyState
              recordId={props.recordId}
              resourceId={props.resourceId}
              isReadOnly={props.isReadOnly}
            />
          </Show>
        </DataStatus>
      </VStack>
    </Box>
  );
}
